// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const FASTAPI_EXPOSED_QUPRO_BASE_URL = 'https://integration-main-fastapi-exposed-qupro-service.dev-aks.grupoarpada.com'

export const environment = {
  production: false,
  apiURL: 'https://api.qupro-odoo10.dev-aks.grupoarpada.com/',
  apiToken: '938753EB7A984BA9AC0A8A9144F5E',
  proveedorApiToken: 'FA75D758509C4CF9B8493B413601969B',
  apiMaxSessionTime: 1000 * 60 * 60 * 23, // 1 day minus 1 hour
  contactAddress: 'desarrollo@grupoarpada.com',
  apiMaxCachedTime: 1000 * 60 * 60 * 10, // 10 hours
  baseUrl: '/',
  version: '0.0.303', // no tocar para que funcione el autoescalado de version en CI/CD
  resetPasswordUrl: 'https://integration-main-proveedor.myvivienda.dev-aks.grupoarpada.com/',
  recaptchaApiKey: '6LclVAsaAAAAAAQd7FZuVd0sNBWrsBlZML9_wOKe',
  viewPermissions: {
    mustSelectOperator: true,
    canAssignOperatorToIssues: false,
    canViewCsitesList: false,
    canViewPostsaleIssuesList: false,
    canViewReviewPresaleIssuesList: false,
    canViewProformasList: false,
    canViewAgreementsList: false,
  },
  recaptchaApiKeyAlias: 'supplier',
  userResetPassword: '',
  passwordUserResetPassword: '',
  appKeyName: 'portal-supplier',
  timeToAccumulateErrors: 500,
  fastapiExposedQuproBaseURL: FASTAPI_EXPOSED_QUPRO_BASE_URL+'',
  fastapiExposedQuproQueriesBaseURL: FASTAPI_EXPOSED_QUPRO_BASE_URL + '/queries/agreements',
  fastapiExposedQuproCommandsBaseURL: FASTAPI_EXPOSED_QUPRO_BASE_URL + '/commands/agreements',
  fastapiExposedQuproHouseContactsBaseURL: FASTAPI_EXPOSED_QUPRO_BASE_URL + '/queries/house-owner-contacts'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
